import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetPredefinedFlashMessageRequest } from './getpredefinedflashmessagesrequest';

export class GetPredefinedFlashMessageAPI extends SixdeeCRBTAPI<GetPredefinedFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        
        return "flash/services/common/get-predefined-flashes";
    }

    protected getRequestData() {
        return {
            "channelId":"1",
            "type":"INSTANT",
            "locale": (this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "en": "my")
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesapi.tsx